module.exports = __webpack_public_path__ + "static/media/exyookay-about-us-edited.78406875.png";